<template>
    <span v-if="!nolabel">
        <b-form-group
            :invalid-feedback="invalidFeedback"
            :state="state"
            label-align="right"
            label-cols="3"
            label-cols-lg="2"
            v-bind="$attrs"
            v-on="$listeners"
        >
            <slot />
        </b-form-group>
        <span v-if="_fs.debug"> {{ invalidFeedback }} <br /> </span>
    </span>

    <span class="nolabel" v-else>
        <slot />

        <span v-if="_fs.debug">
            {{ invalidFeedback }} <br />

            {{ message }}
        </span>

        <b-form-invalid-feedback :state="state">
            {{ invalidFeedback }}
        </b-form-invalid-feedback>
    </span>
</template>
<style scoped>
/*.field .is-horizontal {*/
/*    margin-bottom: 10px;*/
/*}*/
</style>
<script>
import _ from "lodash";

/*
     A wrapper around b-field so we can add nolabel attribute to hide the label in tables etc and still show message

   */
export default {
    name: "OFormGroup",
    props: {
        nolabel: { type: Boolean, default: false },
        message: { type: [String, Array, Object], default: null },
        type: {
            type: [String, Object],
        },
        formState: { type: Object, default: null, required: false },
    },
    computed: {
        _fs() {
            //Use this in render so we can handle No FormState as expected..
            return this.formState || { debug: false };
        },
        state() {
            if (this.message == null) {
                return true;
            }

            return _.isEmpty(this.message);
        },
        invalidFeedback() {
            if (!this.message) {
                return "";
            }

            if (typeof this.message === "string") {
                return this.message;
            } else {
                let results = [];

                if (Array.isArray(this.message)) {
                    this.message.forEach((message) => {
                        if (typeof message === "string") {
                            results.push(message);
                        } else {
                            for (let key in message) {
                                results.push(key);
                            }
                        }
                    });
                } else {
                    for (let key in this.message) {
                        if (this.message[key]) {
                            results.push(key);
                        }
                    }
                }
                return results.join(", ");
            }
        },
    },
};
</script>
